/**
 * 正整数
 */
export const integerRegExp = /^(0|[1-9]\d*)$/

/**
 * 正整数（不包括0）
 */
export const integerRegExpNonZero = /^[1-9]\d*$/

/**
 * 非负数（包含正数、零）
 */
export const positiveRegExp = /^(0|([1-9][0-9]*))(\.[\d]*)?$/
